import { useAppDispatch } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { TextField, MenuItem, Button, Box } from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useGetMechanicsQuery } from 'features/getMechanics/api/getMechanicsApi';
import { useAddMechanicMutation } from 'features/addMechanic/api/addMechanicApi';
import { useGetActivitiesByIdQuery } from 'features/getActivities/api/getActivitiesApi';
import { useParams } from 'react-router-dom';

type FormDataType = {
  id: number;
  mechanic: number;
  title: string;
};

export const AddMechanicDrawer = (promoId: any) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [addMechanicRequest] = useAddMechanicMutation();
  const { data: mechanics } = useGetMechanicsQuery({ isActive: true, size: 50 });
  const { refetch: refetchActivity } = useGetActivitiesByIdQuery({ id });

  const { control, handleSubmit, getValues } = useForm<FormDataType>({
    defaultValues: {
      id: 0,
      mechanic: 0,
      title: '',
    },
  });
  const onSubmit: SubmitHandler<FormDataType> = () => {
    const { promoId: id } = promoId;
    addMechanicRequest({
      id,
      body: {
        objective_id: (getValues() as any).mechanic,
      },
    }).then(() => {
      dispatch(setDrawerOpen(false));
      refetchActivity();
    });
  };
  return (
    <>
      <div>
        <div style={{ marginBottom: '20px' }}>Добавить новую механику</div>
        <Controller
          name="mechanic"
          control={control}
          rules={{
            required: 'Механика обязательна',
          }}
          render={({ field }) => (
            <TextField
              select
              type="text"
              label="Механика"
              placeholder=""
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                marginBottom: '24px',
              }}
              {...field}
            >
              {mechanics && mechanics.items ? (
                mechanics?.items.map((item) => (
                  <MenuItem
                    value={item.id}
                    key={item.id}
                  >
                    {item.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem>loading</MenuItem>
              )}
            </TextField>
          )}
        />
      </div>

      <Box
        sx={{
          display: 'flex',
          marginTop: '30px',
        }}
      >
        <Button
          variant="contained"
          sx={{ textTransform: 'none' }}
          onClick={handleSubmit(onSubmit)}
        >
          Добавить
        </Button>
      </Box>
    </>
  );
};
